import React from 'react';
import { PERMISSION_MODULES, ACTIONS } from './permissionModules';

/* Reusable read/write/delete matrix for the 19 modules, with a Grant/Revoke-All toggle. */
export default function PermissionMatrix({ permissions, setPermissions }) {
    const toggle = (key, action) => {
        setPermissions((prev) => ({
            ...prev,
            [key]: { ...prev[key], [action]: !(prev[key] && prev[key][action]) }
        }));
    };
    const allGranted = PERMISSION_MODULES.every((m) => ACTIONS.every((a) => permissions[m.key] && permissions[m.key][a]));
    const grantAll = () => {
        const val = !allGranted;
        const next = {};
        PERMISSION_MODULES.forEach((m) => { next[m.key] = { read: val, write: val, delete: val }; });
        setPermissions(next);
    };
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="mb-0">Permissions</h5>
                <button type="button" className="btn btn-sm btn-outline-primary" onClick={grantAll}>
                    {allGranted ? 'Revoke All' : 'Grant All'}
                </button>
            </div>
            <div className="table-responsive">
                <table className="table table-bordered align-middle mb-0">
                    <thead className="table-light">
                        <tr>
                            <th>Module</th>
                            <th className="text-center">Read</th>
                            <th className="text-center">Write</th>
                            <th className="text-center">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {PERMISSION_MODULES.map((m) => {
                            const row = permissions[m.key] || { read: false, write: false, delete: false };
                            const full = row.read && row.write && row.delete;
                            return (
                                <tr key={m.key} className={full ? 'table-primary' : ''}>
                                    <td>{m.label}</td>
                                    {ACTIONS.map((a) => (
                                        <td key={a} className="text-center">
                                            <input type="checkbox" checked={!!row[a]} onChange={() => toggle(m.key, a)} />
                                        </td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
